







import {
  defineComponent,
  useContext,
} from '@nuxtjs/composition-api';
// eslint-disable-next-line
import ClientOnly from 'vue-client-only';
import { usePageStore } from '~/stores/page';

import CATEGORY from '~/modules/catalog/pages/category.vue';
import SOLEPRO_CATEGORY from '~/modules/catalog/pages/solepro/category.vue';
import CMS_PAGE from '~/pages/Cms.vue';
import SOLEPRO_CMS_PAGE from '~/pages/solepro/Cms.vue';
import PRODUCT from '~/pages/Product/_slug/index.vue';
import SOLEPRO_PRODUCT from '~/pages/solepro/Product/_slug/index.vue';
import HOT_TOPICS from '~/pages/solepro/HotTopicsPage.vue';
import HOT_TOPIC from '~/pages/solepro/HotTopicPage.vue';
import MBOOKS_PRODUCT from '~/modules/catalog/pages/mbooks/product.vue';
import { useConfig } from '~/composables';
import { MBOOKS_STORE_CODE, SOLEPRO_STORE_CODE } from '~/utils/constants/store';
import { getLayout } from '~/utils/helpers/page';
import Notification from '~/components/Notification.vue';

/**
 * @TODO lazy load components!
 */
export default defineComponent({
  name: 'PageResolver',
  components: {
    CATEGORY,
    CMS_PAGE,
    PRODUCT,
    SOLEPRO_PRODUCT,
    SOLEPRO_CATEGORY,
    SOLEPRO_CMS_PAGE,
    HOT_TOPICS,
    HOT_TOPIC,
    MBOOKS_PRODUCT,
    Notification,
    ClientOnly,
  },
  layout(context) {
    return getLayout(context.i18n.locale);
  },
  middleware: [
    'url-resolver',
  ],
  setup() {
    const { routeData } = usePageStore();
    const { config: storeConfig } = useConfig();
    const storeCode = storeConfig.value.store_code;
    const { i18n } = useContext();

    const getType = () => {
      if (routeData?.type == 'PRODUCT') {
        switch (i18n.locale) {
          case MBOOKS_STORE_CODE: return 'MBOOKS_PRODUCT';break;
          case SOLEPRO_STORE_CODE: return 'SOLEPRO_PRODUCT';break;
          default: return 'PRODUCT';
        }
      } else if (i18n.locale == SOLEPRO_STORE_CODE) {
        if (routeData?.type == 'CATEGORY') {return 'SOLEPRO_CATEGORY';}
        else if(routeData?.type == 'CMS_PAGE') {return 'SOLEPRO_CMS_PAGE';}
        else return routeData?.type;
      } else if(routeData?.type=='HOT_TOPICS' || routeData?.type=='HOT_TOPIC'){
        return 'CATEGORY' // Hot topics not used in stores different from 24orepro
      }else{
        return routeData?.type;
      }
    }
    return {
      type: getType(),
      storeCode,
    };
  },

});
